import { createTheme } from "@mui/material/styles";

const baseTheme = createTheme();

export const shadows = [...baseTheme.shadows] as typeof baseTheme.shadows;

shadows[2] = "rgba(15, 15, 15, 0.05) 0px 2px 16px 2px";
